/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   4/26/22
 */

import React from "react";
import {
	Checkbox,
	FormControl,
	FormControlLabel,
	FormHelperText,
	Stack
} from "@mui/material";
import {EventSubscriptionMessageFormat} from "../../interfaces/Global";
import MessageFormatSelector from "./MessageFormatSelector";
import LinkedCalendarSelector from "../../controls/LinkedCalendarSelector";

export interface ConfigSettingsProps {
	calendarId: number | undefined
	setCalendarId: (id: number | undefined) => void
	includeApproveButton: boolean
	setIncludeApproveButton: (value: boolean) => void
	messageFormat: EventSubscriptionMessageFormat
	setMessageFormat: (format: EventSubscriptionMessageFormat) => void
	disabled?: boolean
}

export default function ConfigSettings(props: ConfigSettingsProps) {

	return (
		<Stack spacing={2}>
			<LinkedCalendarSelector
				calendarId={props.calendarId}
				setCalendarId={props.setCalendarId}
				hint={"If provided, a link to this calendar will be included in a Slack message for quick access."}
			/>
			<FormControl variant={"standard"} fullWidth>
				<FormControlLabel
					control={
						<Checkbox
							checked={props.includeApproveButton}
							disabled={props.disabled}
							onChange={(event) => {
								props.setIncludeApproveButton(event.target.checked);
							}}
						/>
					}
					label="Add Approve button where applicable"
				/>
				<FormHelperText>For single click approvals of unconfirmed calendar events directly from Slack.</FormHelperText>
			</FormControl>
			<MessageFormatSelector
				format={props.messageFormat}
				setFormat={props.setMessageFormat}
			/>
		</Stack>
	);

}